import * as preact from "preact";

interface CustomSelectProps {
  options: {
    value: string;
    label: string;
  }[];
  selectedValue?: string;
  icon?: string;
  onClick?: (event: any) => void;
  onChange?: (value: string) => void;
}

const CustomSelect: preact.FunctionComponent<CustomSelectProps> = (
  props: CustomSelectProps
) => {
  return (
    <label class="customSelectLabel">
      <select
        class="customSelect"
        onClick={props.onClick}
        onChange={(event) => props.onChange?.(event.currentTarget.value)}
        value={props.selectedValue}
      >
        {props.options.map((option) => (
          <option value={option.value}>{option.label}</option>
        ))}
      </select>
      <i class={`icon ${props.icon ?? "icon-sort"}`}></i>
    </label>
  );
};

export default CustomSelect;
